import { combineReducers } from 'redux';
import urlPreview from './urlPreview';
import locations from './locations';

export default combineReducers({
  urlPreview,
  locations,
});



// WEBPACK FOOTER //
// ./src/redux/common/index.js